import styled from "styled-components";

export const StepConditionScheduleReserveContainerStyled = styled.div`
  padding: 20px 20px 46px 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .step_condition_schedule_reserve_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    min-height: calc(100vh - 540px);
    display: flex;
    flex-direction: column;
    .header_layout {
      margin-bottom: 20px;
      &.mb_0 {
        margin-bottom: 0;
      }
    }
    .header_backhome_layout {
      margin-bottom: 32px;
    }
    .title_preview {
      margin-bottom: 28px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .btn_confirm_wrap {
      margin-top: 32px;
    }
    .body_layout {
      margin-bottom: 40px;
      flex: 1;
    }
    .button_layout {
      padding: 20px 42px 0px 42px;
      display: flex;
      justify-content: center;
      column-gap: 36px;
      .button1 {
        flex: 1;
      }
      .button2 {
        flex: 1;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: ${({ isPreview }) =>
      isPreview ? "0px 20px 30px 20px" : "46px 20px"};
    .breadcrumb_layout {
      display: none;
    }
    .step_condition_schedule_reserve_container {
      .header_layout {
        margin-bottom: 30px;
      }
      .button_layout {
        padding: 0;
        display: flex;
        column-gap: 16px;
      }
    }
  }
`;
